export const DEFAULT_MAP_ZOOM = 12;

export const FIELDS = {
  papaCarDescription: 'papaCarDescription',
  papaCarLicensePlate: 'papaCarLicensePlate'
};
